import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import PageHeader from '../../components/ui/PageHeader';
import LoadingScreen from '../../components/ui/LoadingScreen';
import { BrandFields } from '../../components/BrandFields';
import { useToast } from '../../contexts/ToastContext';
import { brandToPayload, emptyTenantForm, tenantToForm } from '../../utils/tenantForm';

function Brand() {
  const toast = useToast();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState(emptyTenantForm);

  useEffect(() => {
    async function load() {
      try {
        const response = await api.post('/partner/brand/get', {});
        const tenant = response.data?.data?.tenant;
        if (tenant) setFormData(tenantToForm(tenant));
      } catch (error) {
        toast.error('Failed to load brand');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [toast]);

  const setField = (key, value) => setFormData((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/partner/brand/update', {
        brand: brandToPayload(formData),
      });
      toast.success('Brand saved');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to save brand');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <LoadingScreen message="Loading brand..." />;
  }

  return (
    <div className="page">
      <PageHeader
        title="Brand"
        description="This theme appears on every customer domain that has not set its own branding. Empty fields keep the Inaiy blue defaults."
      />
      <div className="card">
        <form onSubmit={handleSubmit}>
          <BrandFields
            formData={formData}
            setField={setField}
            hint="Partners define the default look for their customers. A customer domain can still override any field."
          />
          <button type="submit" className="btn btn--primary" disabled={saving} style={{ marginTop: 16 }}>
            {saving ? 'Saving...' : 'Save brand'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Brand;
